import { cn } from '@/shared/lib/utils/classnames';

export interface LoadingSpinnerProps {
  /** Spinner size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Loading text to display below spinner */
  text?: string;
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-16 h-16',
  lg: 'w-24 h-24',
};

/**
 * LoadingSpinner - 공통 로딩 스피너 컴포넌트
 *
 * 전체 앱에서 일관된 로딩 상태를 표시합니다.
 *
 * @example
 * ```tsx
 * <LoadingSpinner size="md" text="데이터 로딩 중..." />
 * ```
 */
export function LoadingSpinner({
  size = 'md',
  text = '로딩 중...',
  className,
}: LoadingSpinnerProps) {
  return (
    <output className={cn('text-center py-16 block', className)} aria-live="polite">
      <div
        className={cn(
          sizeClasses[size],
          'border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4',
        )}
        aria-hidden="true"
      />
      {text && <p className="text-muted-foreground">{text}</p>}
    </output>
  );
}
